import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
    openDUCSnackbar: false,
};

export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: initialState as any,
    reducers: {
        setOpenDUCSnackbar: (state, action: PayloadAction<boolean>) => {
            state.openDUCSnackbar = action.payload;
        }
    }
});

export const { setOpenDUCSnackbar } = sidebarSlice.actions;

export default sidebarSlice.reducer;

export const selectOpenDUCSnackbar = (state: any) => state.sidebar.openDUCSnackbar;